import { history } from 'modules/navigator';
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import MegatronScoresRecharge from '../megatron/scores/recharge';
import ScourgeScoresRecharge from '../scourge/scores/recharge';
import SixshotScoresRecharge from '../sixshot/scores/recharge';
import EswjVip from '../eswj/vip';
import Tiban from '../megatron/tiban';
import EsccVip from '../escc/vip';

import RepaireVip from '../scorponok/vip';
import RepaireScoreRecharge from '../scorponok/scoresRecharge';
import Video from '../scorponok/video';
import VideoDetail from '../scorponok/video/detail';

import EmployToTop from '../megatron/employ/employToTop';
import SelectEmploy from '../megatron/employ/selectEmploy';

import ResumeList from '../megatron/resume/ResumeList';

import sixshotVipCompaire from '../sixshot/vip/compaire';


import scoreRecharge from '../rent/scoreRecharge';
import rentVipCompaire from '../rent/vip/compaire';
import rentVip from '../rent/vip';
import rentVipIgnoreArea from '../rent/vip/ignoreArea';
import rentVipDetail from '../rent/vip/detail';

import trunkScoreRecharge from '../trunk/scoreRecharge';
import trunkVip from '../trunk/vip';
import trunkVipDetail from '../trunk/vip/detail';


class Router extends BrowserRouter {
  public history = history;
}

export default function PaymentApp({ match }) {
  return (
    <Router>
      <Route
        path={`${match.path}/SixshotScoresRecharge`}
        component={SixshotScoresRecharge}
      />
      <Route
        path={`${match.path}/megatronScoresRecharge`}
        component={MegatronScoresRecharge}
      />
      <Route
        path={`${match.path}/scourgeScoresRecharge`}
        component={ScourgeScoresRecharge}
      />
      <Route
        path={`${match.path}/eswjVip`}
        component={EswjVip}
      />
      <Route
        path={`${match.path}/esccVip`}
        component={EsccVip}
      />

      <Route
        path={`${match.path}/repaireVip`}
        component={RepaireVip}
      />
      <Route
        path={`${match.path}/repaireScores`}
        component={RepaireScoreRecharge}
      />
      <Route
        path={`${match.path}/video`}
        component={Video}
      />
      <Route
        path={`${match.path}/videoDetail`}
        component={VideoDetail}
      />

      <Route
        path={`${match.path}/employToTop`}
        component={EmployToTop}
      />
      <Route
        path={`${match.path}/selectEmploy`}
        component={SelectEmploy}
      />
      <Route
        path={`${match.path}/tiban`}
        component={Tiban}
      />

      <Route
        path={`${match.path}/resumeList`}
        component={ResumeList}
      />


      <Route
        path={`${match.path}/sixshotvipcompaire`}
        component={sixshotVipCompaire}
      />

      <Route
        path={`${match.path}/rentScoreRecharge`}
        component={scoreRecharge}
      />
      <Route
        path={`${match.path}/rentvip`}
        component={rentVip}
      />
      <Route
        path={`${match.path}/rentvipIgnoreArea`}
        component={rentVipIgnoreArea}
      />
      <Route
        path={`${match.path}/rentvipdetail`}
        component={rentVipDetail}
      />
      <Route
        path={`${match.path}/rentvipcompaire`}
        component={rentVipCompaire}
      />
      
      <Route
        path={`${match.path}/trunkScoreRecharge`}
        component={trunkScoreRecharge}
      />
      <Route
        path={`${match.path}/trunkvip`}
        component={trunkVip}
      />
      <Route
        path={`${match.path}/trunkvipdetail`}
        component={trunkVipDetail}
      />
      

      
    </Router>
  );
}
